import styled from 'styled-components';

export const PopoverRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    white-space: nowrap;
`;
